import { SimpleTransferOrderReceivingPrintPage } from "@/features/simple-transfer-order-receiving/pages/SimpleTransferOrderReceivingPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/receiving/simple-transfer-order/$id/print",
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["simple_to_receiving.view_detail"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: SimpleTransferOrderReceivingPrintPage,
});
